import { z } from '@/libs/zod';

export const winnerVideoSchema = z.object({
  id: z.string(),
  videoUrl: z.string(),
  title: z.string().nullable(),
  createdAt: z.string(),
});

export const winnerVideosResponseSchema = z.object({
  data: z.array(winnerVideoSchema),
  nextCursor: z.string().nullable(),
  hasMore: z.boolean(),
});

export type WinnerVideo = z.infer<typeof winnerVideoSchema>;
export type WinnerVideosResponse = z.infer<typeof winnerVideosResponseSchema>;
